module.exports = {
    white: "#FFFFFF",
    black: "#000000",
    transparent: "transparent",
    primary: {
      50: "#EDF3FF",
      100: "#DBE3FF",
      200: "#A6B7F7",
      300: "#7D96F0",
      400: "#5473E3",
      500: "#3753B8",
      600: "#1D378C",
    },
    secondary: {
      50: "#F7F7F7",
      100: "#E4E9F0",
      200: "#C8D3DE",
      300: "#A3B3C8",
      400: "#677A8E",
      500: "#394657",
      600: "#171E25",
      700:"#171E25BF",
      800:"#171E25CC"
    },
    warning: {
      50: "#FFF7EB",
      100: "#FCE5C0",
      200: "#FCD997",
      300: "#F5C573",
      400: "#F2B13F",
      500: "#E69C1E",
      600: "#D48600",
    },
    success: {
      50: "#EDFAED",
      100: "#D3F2D5",
      200: "#A3D9A5",
      300: "#75C778",
      400: "#48A84D",
      500: "#408F43",
      600: "#387D3C",
    },
    danger: {
      50: "#FCF0F0",
      300: "#EE9B9B",
      400: "#F05454",
      500: "#CF3E3E",
    },
    orange: {
      50: "#FFF8F0",
      100: "FFF0DE",
      200:"#FCCA9A",
      300: "#FCAF68",
      400: "#F09541",
      500: "#E07A1B",
      600:"#CF6A0C"
    },
    cyan: {
      50: "#F2FEFF",
      100: "#E6FBFC",
      200: "#7DDCE3",
      300: "#37C2CC",
      400: "#05A2AD",
      500: "#058F99",
      600: "#00666E",
    },
    pink: {
      50: "#FFF7FA",
      100: "#FFE6EE",
      200: "#FFB3CC",
      300: "#FC92B6",
      400: "#F06E99",
      500: "#D84677",
      600: "#B6315D",
    },
    salmon: {
      50: "#FFF4F2",
      100: "#FCE9E6",
      200: "#FCD2CA",
      300: "#FFB3A6",
      400: "#F58773",
      500: "#EC715C",
      600: "#D1533D",
    },
    teal: {
      50: "#EBFCFB",
      100: "#D5F5EF",
      200: "#8BDECE",
      300: "#5BCFB9",
      400: "#1AB89B",
      500: "#0B8F77",
      600: "#097662",
    },
    "deep-purple": {
      50: "#FCF2FF",
      100: "#F5E3FA",
      200: "#E2BBED",
      300: "#B67DC7",
      400: "#9755AB",
      500: "#79418A",
      600: "#643A71",
    },
    error: {
      50: "#FCF0F0",
      100: "#FCE6E6",
      200: "#FF9E9E",
      300: "#FF7575",
      400: "#F05454",
      500: "#CF3E3E",
      600: "#BF2A2A",
    },
    google: {
      50: "#DADCE0",
      100: "#F8FAFE",
      200: "#D6E2FA",
    },
  }